import {Component, OnInit, input} from '@angular/core';
import {loadTriggerLeft} from '../animations/main.animations';

@Component({
    selector: 'app-animated-article',
    templateUrl: './animated-article.component.html',
    styleUrls: ['./animated-article.component.scss'],
    animations: [loadTriggerLeft],
    standalone: true
})
export class AnimatedArticleComponent implements OnInit {

  readonly article = input.required<any>();
  constructor() { }

  ngOnInit() {
  }

}
